import { render } from "./Right.vue?vue&type=template&id=0b64f07a&scoped=true&ts=true"
import script from "./Right.vue?vue&type=script&lang=ts"
export * from "./Right.vue?vue&type=script&lang=ts"

import "./Right.vue?vue&type=style&index=0&id=0b64f07a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b64f07a"]])

export default __exports__